import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import Logo from "./Logo";
import { CONTACT_EMAIL, CONTACT_MAILTO } from "../lib/site";

const EXPLORE = [
  { to: "/reviews", label: "Reviews" },
  { to: "/comparisons", label: "Comparisons" },
  { to: "/guides", label: "Guides" },
  { to: "/categories", label: "Categories" },
];
const COMPANY = [
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/affiliate-disclosure", label: "Affiliate Disclosure" },
];
const LEGAL = [
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
];

function Col({ title, items, testid, children }) {
  return (
    <div data-testid={testid} className="min-w-0">
      <h4 className="eyebrow text-indigo-200 mb-5">{title}</h4>
      <ul className="space-y-3">
        {items.map((i) => (
          <li key={i.to}>
            <Link
              to={i.to}
              className="text-sm text-neutral-200 hover:text-white link-underline"
              data-testid={`footer-link-${i.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {i.label}
            </Link>
          </li>
        ))}
        {children}
      </ul>
    </div>
  );
}

function FooterEmail() {
  return (
    <li className="pt-1">
      <a
        href={CONTACT_MAILTO}
        className="inline-flex items-center gap-2 text-sm text-indigo-200 hover:text-white transition-colors [overflow-wrap:anywhere]"
        data-testid="footer-email-link"
      >
        <Mail size={14} className="shrink-0" /> {CONTACT_EMAIL}
      </a>
    </li>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-indigo-950 text-neutral-100 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5 min-w-0">
            <Logo tone="light" size="lg" testid="footer-logo" />
            <p className="mt-5 max-w-md text-neutral-300 text-[15px] leading-relaxed">
              Independent reviews, comparisons, and practical guides to help
              you discover better software for your business.
            </p>
            <p className="mt-6 eyebrow text-indigo-300">Find software worth using.</p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-1 min-[440px]:grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-10 min-w-0">
            <Col title="Explore" items={EXPLORE} testid="footer-explore" />
            <Col title="Company" items={COMPANY} testid="footer-company">
              <FooterEmail />
            </Col>
            <Col title="Legal" items={LEGAL} testid="footer-legal" />
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-indigo-900 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="text-sm text-neutral-300">
            SaaSRadarHub · Independent software research
          </p>
          <p className="text-xs text-neutral-400" data-testid="footer-copyright">
            © {year} SaaSRadarHub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
